import { createStyles, makeStyles, Theme } from '@material-ui/core'
import { ObjectFieldTemplateProps } from '@rjsf/core'

const styles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    body: {
      width: '100%',
    },
    componentsRoot: {
      padding: theme.spacing(1),
      width: '100%',
    },
    listItems: {
      listStyle: 'none',
      padding: 0,
      display: 'flex',
      gap: '1em',
      width: '100%',
      justifyContent: 'space-between',
    },
    item: {
      flex: '1 1 100%',
    },
    titleField: {
      position: 'sticky',
      top: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.paper,
      '& h5': {
        padding: theme.spacing(0, 1),
      },
    },
    titleContainer: {},
  })
)

export const RJSFSameLineFieldTemplate = (props: ObjectFieldTemplateProps) => {
  const cn = styles()

  return (
    <div className={cn.root}>
      {Boolean(props.uiSchema['ui:title']) && (
        <div className={cn.titleField}>
          <div className={cn.titleContainer}>
            <props.TitleField
              id={`${props.idSchema.$id}-title`}
              title={props.uiSchema['ui:title'] || props.title}
              required={props.required}
            />
          </div>
        </div>
      )}
      <div className={cn.body}>
        {(props.uiSchema['ui:description'] || props.description) && (
          <div>
            <props.DescriptionField
              id={`${props.idSchema.$id}-description`}
              description={props.description}
            />
          </div>
        )}
        <div className={cn.componentsRoot}>
          <ul className={cn.listItems}>
            {props.properties.map((element) => {
              return (
                <li key={element.content.key} className={cn.item}>
                  {element.content}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}
